
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiNotificationAdvice as ObiNotificationAdviceElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-notification-advice.js';
 
 
 

 
 export const ObiNotificationAdvice = createComponent({
   react: React,
   tagName: 'obi-notification-advice',
   elementClass: ObiNotificationAdviceElement,
   events: {
     
   }
  });
 
 